import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { initGoogleAnalyticsLazy, initWebVitalsLazy } from './shared/lib/lazy-initialization';

// Lazy initialize Sentry
import('@/shared/lib/sentry').then(m => m.default());
initGoogleAnalyticsLazy();
initWebVitalsLazy();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
